import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ReactNode } from "react";

export type SubtableRecordEntry = {
  key: string;
  value: string | ReactNode | null | undefined;
};

export const renderSubtable = (
  colHeaders: string[],
  rows: SubtableRecordEntry[][],
  ariaLabel: string,
) => {
  return (
    <Table size="small" aria-label={ariaLabel}>
      <TableHead>
        <TableRow>
          {colHeaders.map((header, index) => (
            <TableCell key={`${index}-${header}`}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, iRow) => (
          <TableRow
            key={`${iRow}|${ariaLabel}`}
          >
            {row.map((entry) => (
              <TableCell key={`${entry.key}`}>
                {entry.value}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};